export default __webpack_public_path__ + "static/media/CNV.69c01e59.svg";